// extracted by mini-css-extract-plugin
export var dividerLine = "_5m-0";
export var errorBackground = "_5m-1";